import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { findPathPages } from 'utils/pages';

import { PAGE_PATH } from 'components/config/pages';

import { ReactComponent as ArrowCircle } from 'images/Icons/ArrowCircle.svg';

import styles from 'components/UI/ArrowCircleLink/ArrowCircleLink.module.scss';

const ArrowCircleLink = ({
  title,
  path,
  goBack,
  direction = 'right',
  className,
}) => {
  const navigate = useNavigate();

  const handleBack = useCallback((e) => {
    e.preventDefault();
    navigate(window.history.state?.idx ? -1 : findPathPages(PAGE_PATH.HOME));
  }, []);

  return (
    <Link
      to={path}
      onClick={goBack && handleBack}
      className={classNames(styles.link, styles[direction], className)}
      data-testid="arrow-circle-link-root"
    >
      {title}
      <ArrowCircle
        className={styles.icon}
        data-testid="arrow-circle-link-icon"
      />
    </Link>
  );
};

ArrowCircleLink.propTypes = {
  title: PropTypes.string.isRequired,
  path: PropTypes.string,
  goBack: PropTypes.bool,
  direction: PropTypes.oneOf(['right', 'left']),
  className: PropTypes.string,
};

export default ArrowCircleLink;
